import { createSelector } from 'reselect';
import get from 'lodash/get';

export const selectAllActiveInstances = createSelector(
  state => get(state, 'requests.instancePreview.value', []),
  instances => (Array.isArray(instances) ? instances.filter(instance => instance.isActive) : [])
);
